var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useCallback } from 'react';
/**
 * 强制组件重新渲染更新
 * 远离：state会使组件更新
 * @returns 函数
 */
export var useForceUpdate = function () {
    var _a = __read(useState({}), 2), updateState = _a[1];
    return useCallback(function () {
        updateState({});
    }, []);
};
